<template>
  <div>
    <div style="height: 20rem; overflow: scroll">
      <el-tree
        :data="menus"
        show-checkbox
        default-expand-all
        node-key="id"
        ref="tree"
        highlight-current
        :props="defaultProps">
       <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>{{ data.name }}</span>
         <span style="color: red">{{data.node?('(' + data.node + ')'):''}}</span>
       </span>
      </el-tree>
    </div>
    <div class="dialog-footer">
      <el-button type="primary" @click="doneAction">确 定</el-button>
      <el-button @click="cancelAction">取 消</el-button>
    </div>
  </div>
</template>

<script>
import {updatePermissionFunction} from './employeeApi'

export default {
  name: 'permissionMenu',
  data () {
    return {
      defaultProps: {
        children: 'subMenus',
        label: 'name'
      }
    }
  },
  props: {
    menus: {
      type: Array,
      default: function () {
        return []
      }
    },
    groupData: {
      type: Object,
      default: function () {
        return null
      }
    },
    type: {
      type: Number,
      default: 0 // 0 菜单 1功能点
    }
  },
  mounted () {
    this.updateSelection()
  },
  methods: {
    updateSelection () {
      if (!this.groupData) {
        return
      }
      const ids = this.type === 0 ? this.groupData.menus : this.groupData.functionPointIds
      if (!this.$refs.tree) {
        setTimeout(() => {
          this.$refs.tree.setCheckedKeys(ids)
        }, 1000)
        return
      }
      this.$refs.tree.setCheckedKeys(ids)
    },
    doneAction () {
      let res = this.$refs.tree.getCheckedKeys()
      console.log(res)
      if (this.type === 0) {
        res = res.concat(this.groupData.functionPointIds)
      } else {
        res = res.concat(this.groupData.menus)
      }
      const data = {}
      data.groupId = this.groupData.groupId
      data.functionIds = res
      updatePermissionFunction(data).then(rsp => {
        const {code, message} = rsp
        if (code === 0) {
          this.$message.success('操作成功')
          this.$emit('success')
        } else {
          this.$message.error(message)
        }
      })
    },
    cancelAction () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.dialog-footer{
  margin-top: 2rem;
  align-items: center;
  justify-content: space-between;
  padding-left: 2rem;
  padding-right: 2rem;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/employee/permissionMenu.vue